<div data-test-id="filters">
	<div class="flex flex-col gap-3">
		<div class="flex flex-row items-center">
			<span class="text-lg font-semibold">
				{{ 'compositions.filters.title' | translate }}
			</span>
			<button
				(click)="clearAllFilters()"
				class="btn btn-primary btn-text ml-auto"
			>
				<svg-icon src="assets/icons/icon-delete.svg" />
				{{ 'compositions.filters.clear-all' | translate }}
			</button>
		</div>
		@if (activeFilterChips().length > 0) {
			<div class="mb-3 flex flex-wrap gap-2">
				@for (
					chip of activeFilterChips();
					track chip.group + chip.value
				) {
					<vp-tag
						[clickable]="true"
						(click)="removeFilter(chip.group, chip.value)"
						color="primary"
						data-test-class="active-filter"
						iconTrailing="assets/icons/icon-cross.svg"
					>
						{{ chip.name }}
					</vp-tag>
				}
			</div>
		}
		<hr class="border-ui-100" />
		@for (
			filterGroupItem of filters();
			track filterGroupItem.title;
			let isLast = $last
		) {
			@let isExpanded = expandedGroups().has(filterGroupItem.title);
			@let visibleItems =
				isExpanded
					? filterGroupItem.items
					: filterGroupItem.items.slice(0, ITEMS_LIMIT);
			<div class="flex flex-col gap-1" data-test-class="filter-group">
				<span class="font-semibold">
					{{
						'compositions.filters.type.' + filterGroupItem.title
							| translate
					}}
				</span>
				<div class="flex flex-col gap-3">
					@for (filterItem of visibleItems; track filterItem.value) {
						<div class="flex flex-row">
							<vp-checkbox
								[initialValue]="
									activeFilters()[
										filterGroupItem.title
									]?.includes(filterItem.value) ?? false
								"
								[inputId]="filterItem.value"
								(emittedValue)="
									onFilterChange(
										filterGroupItem.title,
										filterItem.value,
										$event
									)
								"
								class="w-full"
							>
								{{ filterItem.name }}
							</vp-checkbox>
							<span>{{ filterItem.frequency }}</span>
						</div>
					}
					@if (
						!isExpanded &&
						filterGroupItem.items.length > ITEMS_LIMIT
					) {
						<button
							(click)="toggleShowMore(filterGroupItem.title)"
							class="w-fit underline"
							data-test-class="show-more"
						>
							{{ 'global.show-more' | translate }}
						</button>
					}
					@if (!isLast) {
						<hr class="my-3 border-ui-100" />
					}
				</div>
			</div>
		}
	</div>
</div>
